import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import gmsIndia from "../../Assets/Projects/gms-india.png";
import labourlawfirm from "../../Assets/Projects/labourlawfirm.png";
import hhbusiness from "../../Assets/Projects/hhbusiness.png";
import edasi from "../../Assets/Projects/edasi.png";
import quantam from "../../Assets/Projects/quantam.png";
import bodo from "../../Assets/Projects/bodo.png";
import sundown from "../../Assets/Projects/sundown.png";
import significo from "../../Assets/Projects/significo.png";
import videoPlayer from "../../Assets/Projects/videoPlayer.png";
import rejouice from "../../Assets/Projects/rejouice.png";
import lazarev from "../../Assets/Projects/lazarev.png";
import wikiSearch from "../../Assets/Projects/wiki-search.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      {/* PROJECTS */}
      <Container>
        <h1 className="project-heading">
          <strong className="purple">Projects</strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sundown}
              isBlog={false}
              title="Sundown"
              // description=""
              ghLink="https://github.com/mohdaquib171/sundown"
              demoLink="https://mohdaquib171.github.io/sundown/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={significo}
              isBlog={false}
              title="Significo"
              // description=""
              ghLink="https://github.com/mohdaquib171/Significo"
              demoLink="https://mohdaquib171.github.io/Significo/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={rejouice}
              isBlog={false}
              title="Rejouice"
              // description=""
              ghLink="https://github.com/mohdaquib171/rejouice"
              demoLink="https://mohdaquib171.github.io/rejouice/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={lazarev}
              isBlog={false}
              title="Lazarev"
              // description=""
              ghLink="https://github.com/mohdaquib171/lazarev"
              demoLink="https://mohdaquib171.github.io/lazarev/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={wikiSearch}
              isBlog={false}
              title="Wikipedia Search Tool"
              // description=""
              ghLink="https://github.com/mohdaquib171/Wikipedia-Search-Tool"
              demoLink="https://mohdaquib171.github.io/Wikipedia-Search-Tool/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={videoPlayer}
              isBlog={false}
              title="Video Player"
              // description=""
              ghLink="https://github.com/mohdaquib171/HTML5-Video-Player"
              demoLink="https://mohdaquib171.github.io/HTML5-Video-Player/"
            />
          </Col>

        </Row>
      </Container>
      
      {/* Freelance Projects */}
      <Container>
        <h1 className="project-heading">
          <strong className="purple">Freelance Projects </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a freelance projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gmsIndia}
              isBlog={false}
              title="GMS-India"
              // description=""
              ghLink=""
              demoLink="https://www.gms-india.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={labourlawfirm}
              isBlog={false}
              title="LabourLawFirm"
              // description=""
              // ghLink=""
              demoLink="https://labourlawfirm.in"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hhbusiness}
              isBlog={false}
              title="HH Business"
              // description=""
              // ghLink=""
              demoLink="https://hh-business-landing-page.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={edasi}
              isBlog={false}
              title="Edasi"
              // description=""
              // ghLink=""
              demoLink="https://edasi-landing-page.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={quantam}
              isBlog={false}
              title="Quantam Content"
              // description=""
              // ghLink=""
              demoLink="https://quantum-website.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bodo}
              isBlog={false}
              title="Bodo"
              // description=""
              // ghLink=""
              demoLink="https://bodosnap.netlify.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
